var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"image-box",attrs:{"alt":"","src":_vm.srcWithoutProtocol},on:{"click":function($event){return _vm.$emit('click')},"load":_vm.handleImageLoad,"error":_vm.handleError}})
}
var staticRenderFns = []

export { render, staticRenderFns }